import { Link, Text, TagProperties, TextProps } from '@nimbus-ds/components';
import { differenceInDays } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { dateFormat, Format } from 'commons/utils/date';
import goToAdmin from 'commons/utils/gotToAdmin';
import useGetPlanDebt from 'domains/Auth/hooks/useGetPlanDebt/useGetPlanDebt';
import { useGetLastPayment } from 'domains/Billing/Checkout/hooks';
import { trackingBillingPostUpsellAdbarClick } from 'domains/Billing/tracking';
import { AdBar } from './AdBar';

export function PostUpsellPaymentInvitationV2() {
  const { t } = useTranslation('common');
  const { planDebtData } = useGetPlanDebt();
  const { paymentStatus, isSuccess } = useGetLastPayment('plan-cost');

  if (
    !isSuccess ||
    paymentStatus === 'IN_PROCESS' ||
    planDebtData?.nextPaymentDate === undefined
  )
    return null;

  const nextPaymentDate = planDebtData.nextPaymentDate;

  const goToCheckout = goToAdmin('account/checkout/start/');

  const handleClick = () => {
    trackingBillingPostUpsellAdbarClick('post-upsell-payment-invitation');
    goToCheckout();
  };
  const today = new Date();
  const expiresIn = differenceInDays(new Date(nextPaymentDate), today);

  const getAdBarProps = ():
    | {
        appearance: TagProperties['appearance'];
        color: TextProps['color'];
        messageText: string;
      }
    | undefined => {
    if (expiresIn > 0) {
      return {
        appearance: 'primary',
        color: 'primary-textLow',
        messageText: t('topAdBar.postUpsellV2.textv2', {
          count: expiresIn,
        }),
      };
    }
    if (expiresIn === 0) {
      return {
        appearance: 'danger',
        color: 'danger-textLow',
        messageText: t('topAdBar.postUpsellV2.textv2Expired', {
          date: dateFormat(nextPaymentDate, Format.DD_MM),
        }),
      };
    }
  };

  const adBarProps = getAdBarProps();
  if (!adBarProps) return null;

  return (
    <AdBar appearence={adBarProps.appearance}>
      <Text fontWeight="bold" color={adBarProps.color}>
        {adBarProps.messageText}
      </Text>
      <Link onClick={handleClick} appearance="primary" textDecoration="none">
        {t('topAdBar.postUpsellV2.link')}
      </Link>
    </AdBar>
  );
}
